import { FC } from "react";

interface IconCaretDownProps {
  className?: string;
  fill?: boolean;
  duotone?: boolean;
}

const IconCaretDown: FC<IconCaretDownProps> = ({
  className,
  fill = false,
  duotone = true,
}) => {
  return (
    <>
      {!fill ? (
        <svg
          width="14"
          height="7"
          viewBox="0 0 14 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <path d="M13.7092 0.288658C13.6163 0.197192 13.5057 0.124593 13.3839 0.0750502C13.262 0.025507 13.1313 0 12.9993 0C12.8673 0 12.7366 0.025507 12.6148 0.0750502C12.4929 0.124593 12.3824 0.197192 12.2894 0.288658L7.70992 4.7581C7.61697 4.84956 7.50638 4.92216 7.38453 4.9717C7.26269 5.02125 7.132 5.04676 7 5.04676C6.868 5.04676 6.73731 5.02125 6.61547 4.9717C6.49362 4.92216 6.38303 4.84956 6.29008 4.7581L1.7106 0.288658C1.61765 0.197192 1.50706 0.124593 1.38521 0.0750502C1.26337 0.025507 1.13268 0 1.00068 0C0.868682 0 0.737991 0.025507 0.616146 0.0750502C0.4943 0.124593 0.383712 0.197192 0.29076 0.288658C0.10453 0.471497 0 0.718831 0 0.976639C0 1.23445 0.10453 1.48178 0.29076 1.66462L4.88024 6.14382C5.44268 6.69206 6.20509 7 7 7C7.79491 7 8.55732 6.69206 9.11976 6.14382L13.7092 1.66462C13.8955 1.48178 14 1.23445 14 0.976639C14 0.718831 13.8955 0.471497 13.7092 0.288658Z" />
        </svg>
      ) : (
        <svg
          width="15"
          height="8"
          viewBox="0 0 15 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <g clip-path="url(#clip0_15884_61316)">
            <path d="M14.5615 5.48216L9.97548 0.97529C9.30885 0.349311 8.42241 0 7.50048 0C6.57856 0 5.69211 0.349311 5.02548 0.97529L0.439481 5.48216C0.158086 5.75877 0 6.13391 0 6.52509C0 6.91626 0.158086 7.29141 0.439481 7.56801C0.720876 7.84461 1.10253 8 1.50048 8C1.89843 8 2.28009 7.84461 2.56148 7.56801L7.14748 3.06015C7.24124 2.96801 7.3684 2.91625 7.50098 2.91625C7.63356 2.91625 7.76072 2.96801 7.85448 3.06015L12.4395 7.56801C12.7209 7.84461 13.1025 8 13.5005 8C13.8984 8 14.2801 7.84461 14.5615 7.56801C14.8429 7.29141 15.001 6.91626 15.001 6.52509C15.001 6.13391 14.8429 5.75877 14.5615 5.48216Z" />
          </g>
          <defs>
            <clipPath id="clip0_15884_61316">
              <rect width="15.001" height="8" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )}
    </>
  );
};

export default IconCaretDown;
